/**
 * index.js - Punto de entrada de la aplicación React
 *
 * Renderiza el componente principal App en el DOM
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import './theme/tokens.css';
import App from './App';

// Obtener el elemento raíz del DOM
const root = ReactDOM.createRoot(document.getElementById('root'));

// Renderizar la aplicación
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
